import RequestHero from './components/RequestHero';
import RequestHowItWorks from './components/RequestHowItWorks';
import RequestBenefits from './components/RequestBenefits';
import RequestForm from './components/RequestForm';
import CtaBand from '../../../components/feature/CtaBand';
import Breadcrumb from '../../../components/feature/Breadcrumb';
import { useSEOHead } from '../../../hooks/useSEOHead';

export default function RequestAVehiclePage() {
  useSEOHead({
    title: 'Request a Vehicle | Car Broker Oregon | Rockhound Auto',
    description: 'Can\'t find the perfect car? Let our broker team source it for you. We find quality used vehicles that match your needs and budget across Oregon and Washington.',
    keywords: 'request vehicle, car sourcing service, find specific car, auto broker Oregon, vehicle locator service',
    canonicalUrl: 'https://rockhoundauto.com/broker-services/request-a-vehicle',
  });

  return (
    <>
      <Breadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Broker Services', path: '/broker-services' },
          { label: 'Request a Vehicle' }
        ]}
      />
      <RequestHero />
      <RequestHowItWorks />
      <RequestBenefits />
      <RequestForm />
      <CtaBand
        heading="Questions Before You Submit?"
        subheading="Call or text us anytime — we'll walk you through the process and answer any questions about our broker service."
        icon="ri-customer-service-2-line"
        badge="We're Here to Help"
        primaryCta={{
          label: 'Call (855) 468-6348',
          href: 'tel:+18554686348',
          icon: 'ri-phone-line',
        }}
        secondaryCta={{
          label: 'Browse Inventory',
          href: '/inventory',
          icon: 'ri-car-line',
        }}
        variant="dark"
      />
    </>
  );
}